import request from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import { TagType } from "@/types/tags.type";
import TagModule from "@/modules/customer/tags";

const Tags = {
  namespaced: true,
  state: () => ({
    tags: [],
    tag: null,
    success: false,
    message: "",
  }),
  getters: {
    tags: (state: any) => state.tags,
    tag: (state: any) => state.tag,
    success: (state: any) => state.success,
    message: (state: any) => state.message,
  },
  mutations: {
    SET_TAGS_LIST(state: any, tags: Array<TagType> = []) {
      state.tags = tags;
    },

    SET_TAGS_RESULT(state: any, payload: any) {
      state.tag = payload.tag;
      state.success = payload.success;
      state.message = payload.message;
    },
  },
  actions: {
    async getTags({ commit }: { commit: any }) {
      return await request
        .get(ENDPOINTS.TAGS)
        .then((response) => response.data)
        .then(async ({ data }) => {
          const list = data.map((item) => new TagModule(item));
          await commit("SET_TAGS_LIST", list);
        });
    },

    async create({ commit }: { commit: any }, payload) {
      return await request
        .post(ENDPOINTS.TAGS, payload)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_TAGS_RESULT", { tag: new TagModule(data), success: true, message: data.message || "" });
        })
        .catch(async (error) => {
          await commit("SET_TAGS_RESULT", { tag: null, success: false, message: error.message || "" });
        });
    },
  },
};

export default Tags;
